/* eslint-disable n/no-callback-literal */
import dbUser from '@/api/system/user';
import auth from '@/utils/auth';
import i18n from '@/i18n';

// const { login, logout, getInfo } = userModel;
/**
 * 获取登录失败累计字数
 */
const getloginCount = () => {
  const count = auth.getLoginCount();
  if (!count) {
    return 0;
  }
  return parseInt(count, 10);
};
const user = {
  namespaced: true,
  state: {
    // token: getToken(),
    // 记录错误登录次数
    loginCount: getloginCount(),
    logined: false,
    userName: '',
    avatarUrl: '',
    mobile: '',
    name: '',
    email: '',
    avatar: '',
    roles: [],
    permissions: [],
    id: '',
    userInfo: {},
    interConfig: {},
    larkSignature: '', // 飞书签名
  },
  getters: {
    permissions(state) {
      return state.permissions;
    },
  },

  mutations: {
    // 设置错误次数，大于3次数，出现验证码
    setLoginCount: (state, count) => {
      state.loginCount = count;
      auth.setLoginCount(count);
    },
    SET_LOGINED: (state, logined) => {
      state.logined = logined;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },

    SET_USERINFO: (state, data) => {
      const { avatar, name, userName, email, logined, id, mobile, userInfo } = data;
      state.logined = logined;
      state.name = name;
      state.avatar = avatar;
      state.userName = userName;
      state.email = email;
      state.avatar = avatar;
      state.id = id;
      state.mobile = mobile;
      state.userInfo = userInfo;
    },
    SET_INTERCONFIG: (state, data) => {
      state.interConfig = data;
    },
    setLarkInfo(state, content) {
      console.log(content, "飞书认证信息--------", auth.getLocal());
      const lang = auth.getLocal();
      const { openId = "", ticket = "" } = content?.data || {};
      if (!openId || !ticket) {
        // 没有openId或ticket，直接返回 并记录到日志
        return;
      }
      state.larkSignature = ticket;
      const timestamp = Date.now();
      const nonceStr = "Y7a8KkqX041bsSwT";
      const url = window.location.origin;
      const jsapiTicket = `jsapi_ticket=${ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`;
      const CryptoJS = require("crypto-js");
      function sha1(text) {
        return CryptoJS.SHA1(text).toString();
      }
      const signature = sha1(jsapiTicket);
      console.log(`jsapi_ticket=${ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`);
      // 注册飞书组件
      window.webComponent
        .config({
          openId, // 当前登录用户的open id，要确保与生成signature使用的user_access_token相对应
          signature, // 签名
          appId: process.env.VUE_APP_FS_APP_ID, // 应用 appId
          timestamp, // 时间戳（毫秒）
          nonceStr, // 随机字符串
          url, // app URL
          jsApiList: ["user_profile"], // 使用成员名片组件时取值为 ['user_profile']
          locale: lang // 指定组件的国际化语言：en-US 英文、zh-CN 中文、ja-JP 日文
        })
        .then(res => {
          // 可以在这里进行组件动态渲染
        });
    }
  },

  actions: {
    // begin: 获取验证码
    /**
     * 获取验证码随机身份 key
     */
    getKey() {
      return dbUser.getKey().then((resp) => resp);
    },
    /**
     * 根据身份key，获取对应的图片验证码
     * @param {Object} param
     */
    getCode(store, param) {
      return dbUser.getCode(param).then((resp) => resp);
    },
    // end: 验证码
    /**
     * 登录
     * @param {*} store
     * @param {*} userInfo
     */
    Login({ dispatch }, userInfo) {
      return dbUser.login(userInfo).then(({ success }) => {
        if (success) {
          // 将用户名记录 localStorage
          auth.setUserName(userInfo.username);
          dispatch('load');
          return true;
        }
        return false;
      });
    },

    // 获取个人信息
    getMyUserId(state, param) {
      return dbUser.getMyUserId(param);
    },
    /**
     * 退出登录
     * @param {*} param0
     * @param {*} param1
     */
    Logout() {
      return dbUser
        .logout()
        .then(() => true)
        .finally(() => {
          auth.logout();
        });
    },

    /**
     * 检查是否登录
     * @param {*} param0
     * @param {*} callback
     */
    checkLogin({ dispatch }, callback) {
      // 执行多个任务，获取全局数据，包括用户信息、权限、数组字典。此处会影响速度
      async function initCommon() {
        try {
          await dispatch('userInfo');
          await dispatch('system/getSideBarMenu', {}, { root: true });
          await dispatch('common/getDictType', {}, { root: true });
          callback('success');
        } catch (error) {
          callback('error');
        }
      }
      const token = auth.getToken();
      if (token) {
        // 存在token，无论是否正确，尝试连接api接口，如果成功，给回调传true，否则传false
        initCommon();
      } else {
        callback('onauth');
      }
    },

    /**
     * 获取用户基本信息
     * @param {*} param0
     */
    userInfo({ commit, dispatch }) {
      const userName = auth.getUserName();
      return dbUser
        .getInfo({ userName })
        .then((res) => {
          const { avatarUrl, name, loginName, email, accountOpenId, mobile = '' } = res.data;
          commit('SET_USERINFO', {
            avatarUrl,
            name,
            userName: loginName,
            email,
            mobile,
            avatar: avatarUrl,
            logined: true,
            userInfo: res.data,
            id: accountOpenId,
          });
          window.tracker.setUserId(accountOpenId);
        })
        .catch(() => {
          // 获取异常，则重新登录；异常原因是提供的 token 已过期无效，
          // 先移除token
          auth.logout();
        }).finally(() => {
          // 设置飞书认证状态
          dispatch('getLarkInfo')
        });
    },
    getInterConfig({ commit }) {
      return dbUser.getInterConfig().then((res) => {
        if (res.list && res.list.length > 0) {
          const interConfig = {
            'zh-CN': i18n.messages['zh-CN'],
            'en-US': i18n.messages['en-US'],
          };
          res.list.forEach((item) => {
            interConfig['zh-CN'][item.code] = item.labelZhCn;
            interConfig['en-US'][item.code] = item.labelEnUs;
          });
          i18n.setLocaleMessage('zh-CN', interConfig['zh-CN']);
          i18n.setLocaleMessage('en-US', interConfig['en-US']);
          commit('SET_INTERCONFIG', interConfig);
        }
      });
    },
    /**
     * 心跳检查
     */
    healthCheckStatus() {
      return dbUser.healthCheckStatus();
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load({ dispatch }) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        // DB -> store 加载用户名
        // const token = auth.getToken();
        // if (token) {
        //   await dispatch('userInfo');
        //   await dispatch('system/menu/getSideBarMenu', {}, { root: true });
        //   await dispatch('system/menu/navLoad', {}, { root: true });
        // }

        // await dispatch('common/getDictType', {}, { root: true });

        // await dispatch('d2admin/user/load', null, { root: true });

        // DB -> store 加载主题
        // await dispatch('d2admin/theme/load', null, { root: true });
        // // DB -> store 加载页面过渡效果设置
        // await dispatch('d2admin/transition/load', null, { root: true });
        // DB -> store 持久化数据加载上次退出时的多页列表
        // await dispatch('system/page/openedLoad', null, { root: true });
        // // DB -> store 持久化数据加载侧边栏折叠状态
        // await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true });
        // // DB -> store 持久化数据加载全局尺寸
        // await dispatch('d2admin/size/load', null, { root: true });
        // // DB -> store 持久化数据加载颜色设置
        // await dispatch('d2admin/color/load', null, { root: true });
        // end
        resolve();
      });
    },
    // 用于获取clientId
    GetClientId() {
      auth.setClientId('xuzMc0Ysx272O7DM');
      // 成功失败都返回，无实际意义
      // return dbUser
      //   .getInfo()
      //   .then(() => true)
      //   .catch(() => false);
    },
    // SSO登录
    SSOCode2Token(store, payload) {
      return dbUser.SSOCode2Token(payload);
    },
    // 获取飞书认证信息
    getLarkInfo({ commit }, param) {
      return dbUser.getLarkInfo(param).then(content => {
        // 保存信息
        commit("setLarkInfo", content);
      });
    }
  },
};

export default user;
